import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import { Modal } from 'react-bootstrap';
import Tile from './tile';

function EventModel({ show, onCloseEvent, event, settings }) {
  return (
    <Modal show={show} onHide={onCloseEvent}>
      <Modal.Header closeButton>{event.get('title')}</Modal.Header>
      <Modal.Body style={{ padding: '10px 20px', maxHeight: 500, overflow: 'auto' }}>
        <Tile event={event} settings={settings} noTitle withIcon />
      </Modal.Body>
    </Modal>
  );
}

// eslint-disable-next-line react/prefer-stateless-function
export default class CalendarContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      showEventModel: false,
      selectedEvent: null,
    };
  }

  onShowEvent = info => {
    info.jsEvent.preventDefault();
    const { events } = this.props;
    const event = events.find(e => e.get('id') === info.event.id);
    this.setState({
      showEventModel: true,
      selectedEvent: event,
    });
  };
  onHideEvent = () => {
    this.setState({
      showEventModel: false,
      selectedEvent: null,
    });
  };

  render() {
    const { events, settings } = this.props;
    const { showEventModel, selectedEvent } = this.state;
    const calendarEvents = events
      .map(event => {
        const startTime = event.getIn(['date', 'start', 'local']);
        const endTime = event.getIn(['date', 'end', 'local']);

        return {
          id: event.get('id'),
          title: event.get('title'),
          start: startTime,
          end: endTime,
        };
      })
      .toJS();

    const configToViews = {
      month: 'dayGridMonth',
      week: 'timeGridWeek',
      day: 'timeGridDay',
      list: 'listWeek',
    };
    return (
      <div id="calendar-layout">
        {showEventModel && (
          <EventModel
            show={showEventModel}
            onCloseEvent={this.onHideEvent}
            event={selectedEvent}
            settings={settings}
          />
        )}
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
          dayMaxEvents
          selectable
          weekends={settings.get('showCalendarWeekends')}
          height="auto"
          eventClick={this.onShowEvent}
          eventTimeFormat={{
            hour: 'numeric',
            minute: '2-digit',
            meridiem: 'short',
          }}
          initialView={configToViews[settings.get('calendarView')]}
          headerToolbar={{
            left: 'prev,next,today',
            center: 'title',
            right: '',
          }}
          events={calendarEvents}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/event_layouts/calendar.js